// import S3 from 'react-aws-s3';
import { DirectoryClient2 } from '../service/client';

window.Buffer = window.Buffer || require('buffer').Buffer;

// export async function Upload(file, newFileName, dirName) {
//     try {
//         // let config = bucketConfig;
//         // if (dirName !== '') {
//         //     config['dirName'] = dirName;
//         // }
//         // const ReactS3Client = new S3({ ...config, ACL: 'authenticated-read' });
//         // const response = await ReactS3Client.uploadFile(file, newFileName);
//         // return response;
//     } catch (e) {
//         throw e;
//     }
// }

export async function uploadBackend(file, newFileName, dirName) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();  // moved inside the promise

        reader.onloadend = async () => {
            const base64String = reader.result.split(',')[1]; // Get the base64 part
            const payload = {
                filename: file.name,
                filetype: file.type,
                data: base64String,
            };

            try {
                const res = await DirectoryClient2(payload);
                
                resolve(res.data.Location); // Resolve the promise with the Location
            } catch (error) {
                console.error('Error uploading file:', error);
                reject(error); // Reject the promise with error
            }
        };

        reader.onerror = (error) => {
            console.error('FileReader error:', error);
            reject(error); // Reject the promise on FileReader error
        };

        reader.readAsDataURL(file);
    });
}
